// Email Template API — calls sam-dbam template endpoints

const getBaseUrl = () => {
  const url = process.env.REACT_APP_SAM_DBAM_URL;
  if (!url) throw new Error('REACT_APP_SAM_DBAM_URL is not set');
  return url.replace(/\/+$/, '');
};

/**
 * List email templates for an organization, optionally filtered by type.
 * @param {string} orgId
 * @param {string} [templateType] - 'invitation', 'reminder', 'completion'
 */
export async function listTemplates(orgId, templateType) {
  let url = `${getBaseUrl()}/dbam/v1/templates?org_id=${orgId}`;
  if (templateType) url += `&template_type=${templateType}`;
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`listTemplates failed (${resp.status})`);
  const json = await resp.json();
  return json.data || [];
}

/**
 * Get a single email template by ID.
 */
export async function getTemplate(templateId) {
  const resp = await fetch(`${getBaseUrl()}/dbam/v1/templates/${templateId}`);
  if (!resp.ok) throw new Error(`getTemplate failed (${resp.status})`);
  const json = await resp.json();
  return json.data;
}

/**
 * Create a new email template.
 */
export async function createTemplate(template) {
  const resp = await fetch(`${getBaseUrl()}/dbam/v1/templates`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(template),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`createTemplate failed (${resp.status}): ${text}`);
  }
  const json = await resp.json();
  return json.data;
}

/**
 * Update an existing email template.
 */
export async function updateTemplate(templateId, updates) {
  const resp = await fetch(`${getBaseUrl()}/dbam/v1/templates/${templateId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`updateTemplate failed (${resp.status}): ${text}`);
  }
  const json = await resp.json();
  return json.data;
}

/**
 * Delete an email template.
 */
export async function deleteTemplate(templateId) {
  const resp = await fetch(`${getBaseUrl()}/dbam/v1/templates/${templateId}`, {
    method: 'DELETE',
  });
  if (!resp.ok) throw new Error(`deleteTemplate failed (${resp.status})`);
}
